import { render, staticRenderFns } from "./search.vue?vue&type=template&id=464f5e4c&"
import script from "./search.js?vue&type=script&lang=js&"
export * from "./search.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464f5e4c')) {
      api.createRecord('464f5e4c', component.options)
    } else {
      api.reload('464f5e4c', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=464f5e4c&", function () {
      api.rerender('464f5e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/inputs/search.vue"
export default component.exports